import React, { Component } from "react";
import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
export default class Taskmovementhistorytable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.taskmovementhistorytable_Id,
          sortable: true,
          cell: (row) => <span>{row.taskmovementhistorytable_Id}</span>,
        },
        {
          name: "TaskID",
          selector: (row, i) => row.taskID,
          sortable: true,
          cell: (row) => <span>{row.taskID}</span>,
        },
        {
          name: "MovedFromStage",
          selector: (row, i) => row.movedFromStage,
          sortable: true,
          cell: (row) => <span>{row.movedFromStage}</span>,
        },
        {
          name: "MovedToStage",
          selector: (row, i) => row.movedToStage,
          sortable: true,
          cell: (row) => <span>{row.movedToStage}</span>,
        },
        {
          name: "MovedBy",
          selector: (row, i) => row.movedBy,
          sortable: true,
          cell: (row) => <span>{row.movedBy}</span>,
        },
        {
          name: "MovedAt",
          selector: (row, i) => row.movedAt,
          sortable: true,
          cell: (row) => <span>{row.movedAt}</span>,
        },
        {
          name: "TimeInStage",
          selector: (row, i) => row.timeInStage,
          sortable: true,
          cell: (row) => <span>{row.timeInStage}</span>,
        },

        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.TaskmovementhistorytableeditHandler(row)}
                className="bi bi-pen"
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      taskmovementhistorytable_Id: "",
      taskID: "",
      movedFromStage: "",
      movedToStage: "",
      movedBy: "",
      movedAt: "",
      timeInStage: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",
      //***state
    };
  }
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      taskID: "",
      movedFromStage: "",
      movedToStage: "",
      movedBy: "",
      movedAt: "",
      timeInStage: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",
    });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      taskID: "",
      movedFromStage: "",
      movedToStage: "",
      movedBy: "",
      movedAt: "",
      timeInStage: "",
      dummyOne: "",
      dummyTwo: "",
      dummyThree: "",
      dummyFour: "",
      dummyFive: "",
    });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };
  TaskmovementhistorytableeditHandler = (row) => {
    // e.preventDefault();
    this.setState({
      isEditing: true,
      taskmovementhistorytable_Id: row.taskmovementhistorytable_Id,
      taskID: row.taskID,
      movedFromStage: row.movedFromStage,
      movedToStage: row.movedToStage,
      movedBy: row.movedBy,
      movedAt: row.movedAt,
      timeInStage: row.timeInStage,
      dummyOne: row.dummyOne,
      dummyTwo: row.dummyTwo,
      dummyThree: row.dummyThree,
      dummyFour: row.dummyFour,
      dummyFive: row.dummyFive, //***editstate
    });
  };

  TaskmovementhistorytablefetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Taskmovementhistorytable/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  };
  TaskmovementhistorytablesubmitHandler = (e) => {
    e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("taskID", this.state.taskID);
    formData.append("movedFromStage", this.state.movedFromStage);
    formData.append("movedToStage", this.state.movedToStage);
    formData.append("movedBy", this.state.movedBy);
    formData.append("movedAt", this.state.movedAt);
    formData.append("timeInStage", this.state.timeInStage);
    formData.append("dummyOne", this.state.dummyOne);
    formData.append("dummyTwo", this.state.dummyTwo);
    formData.append("dummyThree", this.state.dummyThree);
    formData.append("dummyFour", this.state.dummyFour);
    formData.append("dummyFive", this.state.dummyFive);

    //***tableData*
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Taskmovementhistorytable/add", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.TaskmovementhistorytablefetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            taskID: "",
            movedFromStage: "",
            movedToStage: "",
            movedBy: "",
            movedAt: "",
            timeInStage: "",
            dummyOne: "",
            dummyTwo: "",
            dummyThree: "",
            dummyFour: "",
            dummyFive: "",
          });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  TaskmovementhistorytableupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append(
      "taskmovementhistorytable_Id",
      this.state.taskmovementhistorytable_Id
    );
    formData.append("taskID", this.state.taskID);
    formData.append("movedFromStage", this.state.movedFromStage);
    formData.append("movedToStage", this.state.movedToStage);
    formData.append("movedBy", this.state.movedBy);
    formData.append("movedAt", this.state.movedAt);
    formData.append("timeInStage", this.state.timeInStage);
    formData.append("dummyOne", this.state.dummyOne);
    formData.append("dummyTwo", this.state.dummyTwo);
    formData.append("dummyThree", this.state.dummyThree);
    formData.append("dummyFour", this.state.dummyFour);
    formData.append("dummyFive", this.state.dummyFive);

    //***tableData1
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Taskmovementhistorytable/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.TaskmovementhistorytablefetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  componentDidMount() {
    this.TaskmovementhistorytablefetchHandler();

    //***componentDidMount
  }
  handletaskIDChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ taskID: fieldValue });
  };
  handlemovedFromStageChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ movedFromStage: fieldValue });
  };
  handlemovedToStageChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ movedToStage: fieldValue });
  };
  handlemovedByChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ movedBy: fieldValue });
  };
  handlemovedAtChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ movedAt: fieldValue });
  };
  handletimeInStageChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ timeInStage: fieldValue });
  };
  handledummyOneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyOne: fieldValue });
  };
  handledummyTwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyTwo: fieldValue });
  };
  handledummyThreeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyThree: fieldValue });
  };
  handledummyFourChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFour: fieldValue });
  };
  handledummyFiveChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyFive: fieldValue });
  };
  //***inputFunctions
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append(
      "taskmovementhistorytable_Id",
      row.taskmovementhistorytable_Id
    );
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Taskmovementhistorytable/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.TaskmovementhistorytablefetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Task Movement History Table
                      </h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary"
                        style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Add Taskmovementhistorytable
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        TaskID
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handletaskIDChange}
                                        className="form-control"
                                        name="taskID"
                                        value={this.state.taskID}
                                        required="required"
                                        placeholder="Enter TaskID"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        MovedFromStage
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlemovedFromStageChange
                                        }
                                        className="form-control"
                                        name="movedFromStage"
                                        value={this.state.movedFromStage}
                                        required="required"
                                        placeholder="Enter MovedFromStage"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        MovedToStage
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlemovedToStageChange}
                                        className="form-control"
                                        name="movedToStage"
                                        value={this.state.movedToStage}
                                        required="required"
                                        placeholder="Enter MovedToStage"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        MovedBy
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlemovedByChange}
                                        className="form-control"
                                        name="movedBy"
                                        value={this.state.movedBy}
                                        required="required"
                                        placeholder="Enter MovedBy"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        MovedAt
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlemovedAtChange}
                                        className="form-control"
                                        name="movedAt"
                                        value={this.state.movedAt}
                                        required="required"
                                        placeholder="Enter MovedAt"
                                      />
                                    </Col>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        TimeInStage
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handletimeInStageChange}
                                        className="form-control"
                                        name="timeInStage"
                                        value={this.state.timeInStage}
                                        required="required"
                                        placeholder="Enter TimeInStage"
                                      />
                                    </Col>
                                  </Row>
                                  <br />

                                  {/* tableContent */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={
                                    this.TaskmovementhistorytablesubmitHandler
                                  }
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>
                      {this.state.isEditing && (
                        // Edit Offcanvas
                        <Offcanvas
                          show={this.state.isEditing}
                          // onHide={() => this.setState({ isEditing: false })}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                              Edit Taskmovementhistorytable
                            </Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          TaskID
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handletaskIDChange}
                                          className="form-control"
                                          name="taskID"
                                          value={this.state.taskID}
                                          required="required"
                                          placeholder="Enter TaskID"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          MovedFromStage
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlemovedFromStageChange
                                          }
                                          className="form-control"
                                          name="movedFromStage"
                                          value={this.state.movedFromStage}
                                          required="required"
                                          placeholder="Enter MovedFromStage"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          MovedToStage
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlemovedToStageChange
                                          }
                                          className="form-control"
                                          name="movedToStage"
                                          value={this.state.movedToStage}
                                          required="required"
                                          placeholder="Enter MovedToStage"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          MovedBy
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlemovedByChange}
                                          className="form-control"
                                          name="movedBy"
                                          value={this.state.movedBy}
                                          required="required"
                                          placeholder="Enter MovedBy"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          MovedAt
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlemovedAtChange}
                                          className="form-control"
                                          name="movedAt"
                                          value={this.state.movedAt}
                                          required="required"
                                          placeholder="Enter MovedAt"
                                        />
                                      </Col>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          TimeInStage
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handletimeInStageChange
                                          }
                                          className="form-control"
                                          name="timeInStage"
                                          value={this.state.timeInStage}
                                          required="required"
                                          placeholder="Enter TimeInStage"
                                        />
                                      </Col>
                                    </Row>
                                    <br />

                                    <br />
                                    {/* tableContent */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={
                                      this.TaskmovementhistorytableupdateHandler
                                    }
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
